import getValue from './../GetValue';

const STORAGE_KEY = 'seamlesspay';

export const loadStateData = () => {
  try {
    const serializedState = localStorage.getItem(STORAGE_KEY);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (e) {

    return undefined;
  }
};

export const saveStateData = (data) => {
  const currentData = { ...loadStateData(), ...data };
  try {
    const serializedData = JSON.stringify(currentData);
    localStorage.setItem(STORAGE_KEY, serializedData);
  } catch (e) {
    throw e;
  }
};

export const getDataByKey = (keyPath) => {
  const storeData = loadStateData();
  if (!storeData) return false;
  return getValue(storeData, keyPath);
};
